'use client';

import React from 'react';
import classNames from 'classnames';
import { isEmpty, resolveSetting } from '../../../utils/settingsHelper';
import {
	containerWidthOptions,
	horizontalPaddingOptions,
	spacingOptions,
	verticalMarginOptions,
} from '../../editor/Toolbar/options';

export const getBgImageStyle = (src, position, size) => (src ? {
	background: `url(${src})  ${position || 'center'} / ${size || 'cover'} no-repeat`,
} : '');

export const getPageSectionClasses = (props) => classNames(
	verticalMarginOptions[props.verticalMargin],
	spacingOptions[props.spacing],
	horizontalPaddingOptions[props.horizontalPadding],
);

export const getPageSectionStyle = (props, settings) => {
	const {
		justifyContent,
		textAlign,
		background,
		background2,
		bgGradientDirection,
		color,
	} = props;

	const bgProps = { background: '' };

	const bgColor = isEmpty(background2) ? resolveSetting(background, settings)
		: `linear-gradient(${bgGradientDirection || 'to right'}, ${resolveSetting(background, settings)}, ${resolveSetting(background2, settings)})`;
	bgProps.background += bgProps.background ? `, ${bgColor}` : bgColor;

	return {
		justifyContent,
		textAlign,
		...bgProps,
		color: resolveSetting(color, settings),
	};
};
export function PageSection(props) {
	const {
		children,
		settings,
		maxWidth,
		innerMaxWidth,
		backgroundImage,
		backgroundPosition,
		backgroundSize,
		mobileBackgroundImage,
		mobileBackgroundPosition,
		mobileBackgroundSize,
		isFooter,
	} = props;

	const Tag = isFooter ? 'footer' : 'section';

	return (
		<Tag
			className="flex w-full"
			style={getPageSectionStyle(props, settings)}
			id={props.id}
		>
			<style jsx>
				{`
                    @media (min-width: 641px) {
                        .background {
                            background: ${getBgImageStyle(backgroundImage, backgroundPosition, backgroundSize).background}
                        }
                    }

        @media (max-width: 640px) {
            .background {
                background: ${getBgImageStyle(mobileBackgroundImage, mobileBackgroundPosition, mobileBackgroundSize).background}
          }
        }
      `}
			</style>
			<div
				className="w-full mx-auto page-section-inner background"
				style={{ maxWidth: containerWidthOptions[maxWidth] }}
			>
				<div className={classNames('mx-auto', getPageSectionClasses(props))} style={{ maxWidth: innerMaxWidth ? containerWidthOptions[innerMaxWidth] : null }}>
					{children}
				</div>
			</div>
		</Tag>
	);
}
